import * as React from "react";
function SvgBubbleBang(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M17 7H3a2 2 0 00-2 2v14a2 2 0 002 2h16l6 6v-6h4a2 2 0 002-2V9a2 2 0 00-2-2h-2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
      <circle cx={22} cy={16} r={2} />
      <path d="M24 2a2 2 0 10-4 0l1 9a1 1 0 002 0z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBubbleBang);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
